import React from 'react';

interface BasicInfoDialogInterface {
    closeDialog: any;
};

function BasicInfoDialog({closeDialog}: BasicInfoDialogInterface) {
    const closeIcon = require("../images/close.png");
    const warning = require("../images/warning.png");
    const refreshIcon = require("../images/refreshBlack.png");
    const announcements = require("../images/announcementsBlack.png");
    const rules = require("../images/rulesBlack.png");
    const removePlayer = require("../images/removePlayerRedBlack.png");
    const judgeHammer = require("../images/judgeHammerBlack.png");

    const handleClose = () => {
        closeDialog()
    }

    return (
        <div className="basicInfoDialogWrapper">
            <div className="dialogTop">
                <div className="dialogCloseWrapper" tabIndex={0} onClick={handleClose} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleClose();
                    }
                }}>
                    <img className="dialogCloseIcon" src={closeIcon} alt="close"/>
                </div>
            </div>
            <div className="basicInfoDialogMiddle">
                <div className="basicInfoDialogTitle">Basic Info</div>
                <div className="basicInfoDialogInfoWrapper">
                    <img className="basicInfoDialogIcon" src={warning} alt="warning"/>
                    <div className="basicInfoDialogInfo">Don't refresh or close the browser, or you won't be able to came back to the game</div>
                </div>
                <div className="basicInfoDialogInfoWrapper">
                    <img className="basicInfoDialogIcon" src={refreshIcon} alt="refresh"/>
                    <div className="basicInfoDialogInfo">Refresh if game gets out of sync</div>
                </div>
                <div className="basicInfoDialogInfoWrapper">
                    <img className="basicInfoDialogIcon" src={announcements} alt="read out loud"/>
                    <div className="basicInfoDialogInfo">Read the card out loud</div>
                </div>
                <div className="basicInfoDialogInfoWrapper">
                    <img className="basicInfoDialogIcon" src={rules} alt="rules"/>
                    <div className="basicInfoDialogInfo">Game rules</div>
                </div>
                <div className="basicInfoDialogInfoWrapper">
                    <img className="basicInfoDialogIcon" src={removePlayer} alt="remove players"/>
                    <div className="basicInfoDialogInfo">Kicks player(s) out (host only)</div>
                </div>
                <div className="basicInfoDialogInfoWrapper">
                    <div className="basicInfoDialogCriminal"></div>
                    <div className="basicInfoDialogInfo">Identifies the player who receives a red card for the round</div>
                </div>
                <div className="basicInfoDialogInfoWrapper">
                    <img className="basicInfoDialogIcon" src={judgeHammer} alt="judge"/>
                    <div className="basicInfoDialogInfo">Identifies Judge for the round</div>
                </div>
            </div>
        </div>
    );
};

export default BasicInfoDialog;